export const buildGAScript = (id: string) => (
  `
    window.dataLayer = window.dataLayer || [];

    function gtag(){
      dataLayer.push(arguments);
    }

    gtag('js', new Date());
    
    gtag('config', '${id}', {send_page_view: false});
  `
);
